<template>
    <div class="home-charts-list">
        <div class="charts-head">
            <div class="charts-head-title">
                <div class="header-title">
                    <span class="header-title-text">{{ config.title }}</span>
                    <el-tooltip effect="dark" :content="config.titleTips" placement="top">
                        <img class="icon-pic" v-if="config.titleTips" @mouseenter="mouseenter(config.titleTipsProp)"
                            src="@/assets/images/icon-question.png" />
                    </el-tooltip>
                </div>
                <div class="header-link" v-if="showMoreLink">
                    <span :class="['first-more', config.classNameMore]" @click="openLink()">
                        查看更多<i class="el-icon-arrow-right el-icon--right"></i>
                    </span>
                </div>
            </div>

        </div>
        <div class="home-customer-box">
            <div class="home-customer-content" v-for="(item,index) in config.headConfig" :key="index">
                <span class="customer-content-title">
                    {{ item.title }}
                </span>
                <span class="customer-content-detail">
                    <span class="detail-one">{{customerData[item.titleProp]}}</span>
                    <span v-if="item.titleRankProp" :class="['detail-two',customerData[item.titleRankProp]>0?'detail-up':'detail-down']" >
                        {{customerData[item.titleRankProp]}}
                    </span>
                     <img class="detail-icon-pic" v-if="item.titleRankProp" @mouseenter="mouseenter(config.titleTipsProp)"
                            :src="customerData[item.titleRankProp]>0?iconUp:iconDown" />
                </span>
            </div>
        </div>
    </div>

</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api';
import bigDataLog from '@/utils/bigDataLog.js';
import { Message } from 'element-ui';

import iconUp from '@/assets/images/icon-up.png';
import iconUp2 from '@/assets/images/icon-up2.png';
import iconDown from '@/assets/images/icon-down.png';
import iconDown2 from '@/assets/images/icon-down2.png';
const bigDataLogList = {
    notice: 'bigData-btn-home-page-notice-page',
    marketing: 'bigData-btn-home-page-marketing-page',
    overdueOverview: 'bigData-btn-home-page-overdue-overview-page'
};
export default {
    components: { },
    props: {
        currentRole: {
            type: Object,
            return: () => {
                return {};
            }
        },
        config: {
            type: Object,
            return: () => {
                return {};
            }
        },
        customerData: {
            type: Object,
            return: () => {
                return {};
            }
        },
        searchData: {
            type: Object,
            return: () => {
                return {};
            }
        },
        showMoreLink: {
            type: Boolean,
            default: true
        }

    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const mouseenter = (val) => {
            bigDataLog.sendDetailMessageByKey(bigDataLogList[val]);
        };
        const ctx = getCurrentInstance();
        const routerLink = computed(() => {
            return (props.currentRole.dataType === 'personal' ? 'personal' : 'org') + props.config.routerLink;
        });
        const openLink = val => {
            if (props.config.routerLink) {
                ctx.$router.push({
                    name: routerLink.value,
                    params: { ...props.searchData, ...props.currentRole }
                });
            } else if (props.config.openLink) {
                window.open(props.config.openLink);
            } else {
                Message.warning('链接异常，请联系管理员');
            }
        };
        return {
            iconUp,
            iconUp2,
            iconDown,
            iconDown2,
            mouseenter,
            openLink
        };
    }
};
</script>
<style lang="less" scoped>
.charts-head-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .header-title-text {
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 14px;
    }

    .header-title-time {
        font-size: 12px;
        color: #86909C;
        line-height: 12px;
        margin-top: 2px;
    }

    .first-more {
        position: relative;
        cursor: pointer;
        color: #2881FF;
    }

    .icon-pic {
        width: 14px;
        height: 14px;
        margin-left: 4px;
    }

    .head-unit {
        line-height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        margin-left: 8px;
    }
}

.charts-head-data {
    display: flex;
    flex-direction: column;
    flex: 1;

    .item {
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: flex-start;
    }

    .c-item-head {
        display: flex;
        align-items: center;
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        line-height: 12px;
        margin-top: 3px;

        .icon-pic {
            width: 12px;
            height: 13px;
            margin-left: 4px;
        }
    }

    .c-item-bot {
        display: flex;
        align-items: flex-end;
        height: 20px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-top: 8px;

        .c-item-bot-per {
            display: inline-block;
            align-items: center;
            margin-left: 8px;
            border-radius: 2px;
            color: #86909C;

            .bot-up-pic,
            .bot-down-pic {
                width: 8px;
                height: 8px;
            }
        }

        .c-item-up-bg {
            padding: 0 4px;
            color: #0BB861;
            background: rgba(11, 184, 97, 0.06);
        }

        .c-item-down-bg {
            padding: 0 4px;
            color: #F44837;
            background: rgba(244, 72, 55, 0.06);

        }
    }

    .c-item-bot-num {
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
    }
}

.charts-pie-body {
    display: flex;
    flex-direction: row;
    margin-top: 55px;

    .pie-left {
        flex: 1;
        display: flex;
        justify-content: center;

        .pie-box {
            width: 230px;
        }
    }

    .pie-right {
        flex: 2;
        margin-top: 22px;

        .radio-text {
            display: flex;
            justify-content: flex-end;
        }
    }
}
.home-customer-box{
    display: flex;
    justify-content: space-between;
    .home-customer-content{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-top: 16px;
        flex: 1;
        .customer-content-title{
            font-size: 12px;
            font-weight: 400;
            color: #86909C;
            line-height: 12px;
        }
        .customer-content-detail{
            height: 16px;
            font-size: 16px;
            font-weight: 600;
            color: #333333;
            line-height: 16px;
            margin-top:8px;
            .detail-one{
            }
            .detail-two{
                width: 8px;
                height: 12px;
                font-size: 12px;
                font-weight: 400;
                line-height: 12px;
                margin-left: 4px;
            }
            .detail-up{
                color: #0BB861;
            }
            .detail-down{
                color: #F44837;
            }
            .detail-icon-pic{
                width: 8px;
                height: 8px;
            }
        }
    }
}
</style>
